import React from "react";
import { formatDateTime, formatPrice } from 'lib/utils/formatters';

interface CurrentOfferData {
  id: string;
  createdAt: string;
  offer_amount: number;
  status: string;
  customer: {
    id: string;
    first_name: string;
    last_name: string;
  };
}

interface CurrentOfferProps {
  currentOfferData?: CurrentOfferData;
}

// Function to get badge color based on offer status
const getStatusBadgeClass = (status: string) => {
  switch (status?.toLowerCase()) {
    case 'accepted':
      return 'badge pill bg-success';
    case 'rejected':
      return 'badge pill bg-danger';
    case 'pending':
      return 'badge pill bg-warning';
    case 'under_review':
      return 'badge pill bg-info';
    default:
      return 'badge pill bg-secondary';
  }
};

const cellStyle = {
  textAlign: "left" as const,
  padding: "12px",
  borderBottom: "1px solid #eee",
  // border: "none" // vertical lines hatane ke liye
};

const CurrentOffer: React.FC<CurrentOfferProps> = ({ currentOfferData }) => {
  // If there's current offer data, show it; otherwise show the static data
  const hasCurrentOffer = currentOfferData && currentOfferData.id;
  
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 600, border: "1px solid #eee" }}>
        <thead>
          <tr style={{ background: "#fff" }}>
            <th style={cellStyle}>Offer Amount</th>
            <th style={cellStyle}>Time</th>
            <th style={cellStyle}>By</th>
            <th style={cellStyle}>Status</th>
          </tr>
        </thead>
        <tbody>
          {hasCurrentOffer ? (
            <tr>
              <td style={cellStyle}>{`$${formatPrice(currentOfferData.offer_amount)}`}</td>
              <td style={cellStyle}>{formatDateTime(currentOfferData.createdAt)}</td>
              <td style={cellStyle}>{`${currentOfferData.customer.first_name} ${currentOfferData.customer.last_name}`}</td>
              <td style={cellStyle}>
                <span className={getStatusBadgeClass(currentOfferData.status)}>
                  {currentOfferData.status.charAt(0).toUpperCase() + currentOfferData.status.slice(1)}
                </span>
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan={4} style={{ ...cellStyle, textAlign: "center", color: "#6c757d", fontStyle: "italic" }}>
                No current offer available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CurrentOffer;
